import React from 'react';
import { Box } from '@mui/material';
import { color, radius } from '../../theme/tokens';

// Tones map to the semantic palette in tokens.js
const TONES = {
  neutral: color.neutral,
  success: color.success,
  warning: color.warning,
  danger:  color.danger,
  info:    color.info,
  gold:    color.goldTone,
};

/**
 * Compact status pill used for order/user/store/stock states.
 * `tone` can be a token name or a full { bg, border, text, solid } object.
 */
const StatusBadge = ({ label, tone = 'neutral', dot = true, sx }) => {
  const t = typeof tone === 'string' ? (TONES[tone] || TONES.neutral) : tone;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        px: 1,
        py: 0.25,
        height: 24,
        borderRadius: `${radius.sm}px`,
        backgroundColor: t.bg,
        border: `1px solid ${t.border}`,
        color: t.text,
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: 'nowrap',
        ...sx,
      }}
    >
      {dot && (
        <Box
          component="span"
          sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: t.solid, flexShrink: 0 }}
        />
      )}
      {label}
    </Box>
  );
};

export default StatusBadge;
